import { EVENT_STATUS } from '../../constants/event';

export function isLiveOrComing(event) {
    return [EVENT_STATUS.LIVE, EVENT_STATUS.COMING].includes(event.status);
}

export default function sortEvents(events, activeLiveContent = {}) {
    return events.sort((a, b) => {
        if(activeLiveContent && activeLiveContent.id && activeLiveContent.contentType === 'live_event'){
            if (a.id === activeLiveContent.id) return -1;
            if (b.id === activeLiveContent.id) return 1;
        }

        if (isLiveOrComing(a) && !isLiveOrComing(b)) return -1;
        if (!isLiveOrComing(a) && isLiveOrComing(b)) return 1;

        return 0;
    });
}
